import {
  CreateSessionResponseEnum,
  type CreateSessionSuccess,
  FinalizeUserResponseEnum,
  type FinalizeUserSuccess,
  type FinalizedRequired,
  type MatchingAccountsFound,
} from "@b2bportal/auth-api";
import { getObjectKeysAsObject } from "@hopper-b2b/checkout";
import type { DoneInvokeEvent } from "xstate";
import type { AuthMachineContext } from "./context";

export const AuthGuards = {
  isVerifySuccess: (
    _ctx: AuthMachineContext,
    event: DoneInvokeEvent<CreateSessionSuccess | FinalizedRequired>
  ) =>
    event.data.CreateSessionResponse ===
    CreateSessionResponseEnum.CreateSessionSuccess,
  isFinalizeMatchingAccount: (
    _ctx: AuthMachineContext,
    event: DoneInvokeEvent<FinalizeUserSuccess | MatchingAccountsFound>
  ) =>
    event.data.FinalizeUserResponse ===
    FinalizeUserResponseEnum.MatchingAccountsFound,
};

export const AuthGuardTypes = getObjectKeysAsObject(AuthGuards);
